export default function nl2br(text?: string, replace = true) {
    if (!text) {
        return '';
    }

    const replaceWith = replace ? '$1<br>' : '$1<br>$2';

    return `${text}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceWith);
}
